// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments__radio-buttons-container {
    width: fit-content;
}

.comments__comments-container {
    margin-top: 2rem;
}

.comments__my-comments {
    margin-top: 2rem;
}

.comments__comments-tabs {
    width: fit-content;
    margin-left: 50%;
    margin-bottom: 2rem;
    transform: translateX(-50%);
}

.comments__comments-tabs_sub-tab {
    font-size: 1rem;
}

.comments__comments-not-allowed-icon {
    height: 50px;
    width: 50px;
}

.comments__skeleton-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.comments__comments-container__skeleton {
    height: 60px;
}

.comments__disabled-communicate--wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 200px;
    justify-content: center;
}

.newCommentForm__attachmentsContainer {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.newCommentForm__attachmentsContainer-button {
    width: fit-content;
}

.newCommentForm__attachmentsContainer__chipsContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.newCommentForm__attachmentsContainer__chipsContainer__chip {
    background-color: rgba(3, 87, 166, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/pages/planningApplication/PlanningApplication.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,uCAAuC;AAC3C","sourcesContent":[".comments__radio-buttons-container {\n    width: fit-content;\n}\n\n.comments__comments-container {\n    margin-top: 2rem;\n}\n\n.comments__my-comments {\n    margin-top: 2rem;\n}\n\n.comments__comments-tabs {\n    width: fit-content;\n    margin-left: 50%;\n    margin-bottom: 2rem;\n    transform: translateX(-50%);\n}\n\n.comments__comments-tabs_sub-tab {\n    font-size: 1rem;\n}\n\n.comments__comments-not-allowed-icon {\n    height: 50px;\n    width: 50px;\n}\n\n.comments__skeleton-container {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n}\n\n.comments__comments-container__skeleton {\n    height: 60px;\n}\n\n.comments__disabled-communicate--wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 200px;\n    justify-content: center;\n}\n\n.newCommentForm__attachmentsContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.newCommentForm__attachmentsContainer-button {\n    width: fit-content;\n}\n\n.newCommentForm__attachmentsContainer__chipsContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.newCommentForm__attachmentsContainer__chipsContainer__chip {\n    background-color: rgba(3, 87, 166, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
